import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Typography, FormHelperText, GridList, GridListTile } from '@material-ui/core';

const FormImagePickerGroup = ({
  input,
  label,
  meta: { touched, error },
  values,
  disabled,
  multiChoice,
}) => (
    <FormControl component="fieldset" error={touched && error ? true : false} disabled={disabled} fullWidth>
      {label && <Typography variant="caption" gutterBottom color="textSecondary" style={error ? { color: 'red' } : {}}>{label}</Typography>}
      <div className="gallery-content">
        <GridList cellHeight={160} style={{ margin: 0, padding: 0 }} cols={values.length < 4 ? values.length : 4}>
          {values.map(value => (
            <GridListTile key={value.value}>
              <a onClick={() => input.onChange(multiChoice ? input.value.includes(value.value) ? [...input.value.filter(v => v !== value.value)] : [...input.value, value.value] : value.value)} style={{margin: 15}}>
                <img 
                  className="image-picker-image"
                  src={value.imageUrl} 
                  alt={value.name} 
                  title={value.name}
                  style={{ height: 130, objectFit: 'cover', cursor: 'pointer', borderStyle: 'solid', borderWidth: (multiChoice ? input.value.includes(value.value) : input.value === value.value) ? 3 : 0 }}
                />
              </a>
            </GridListTile>
          ))}
        </GridList>
      </div>
      {touched && error ? <FormHelperText id="radio-error-text" error style={{ marginTop: 0 }}>{error}</FormHelperText> : null}
    </FormControl>
  );

FormImagePickerGroup.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  allowOwnAnswer: PropTypes.bool,
  ownAnswerName: PropTypes.string,
  ownAnswerFieldName: PropTypes.string,
  multiChoice: PropTypes.bool,
};

export default FormImagePickerGroup;



// WEBPACK FOOTER //
// ./src/components/form/FormImagePickerGroup.js